// SAIA No Drama theme JS
(function () {
  'use strict';

  // Mark JS as active so progressive enhancement (scroll-reveal etc) can opt-in.
  // Page is visible by default via CSS animation — this is just for opt-in effects.
  document.documentElement.classList.add('js-active');
  document.body.classList.add('ready', 'js-active');

  // ----- Mobile nav -----
  function bindMobileNav() {
    var btn = document.getElementById('menuBtn');
    var overlay = document.getElementById('mobileNavOverlay');
    var nav = document.getElementById('mobileNav');
    var close = document.getElementById('mobileNavClose');
    if (!btn || !overlay || !nav || !close) return;
    var open = function () { overlay.classList.add('open'); nav.classList.add('open'); document.body.style.overflow = 'hidden'; };
    var shut = function () { overlay.classList.remove('open'); nav.classList.remove('open'); document.body.style.overflow = ''; };
    btn.addEventListener('click', open);
    close.addEventListener('click', shut);
    overlay.addEventListener('click', shut);
  }

  // ----- Cart drawer -----
  function crossAddError(card, msg) {
    if (!card) return;
    var el = card.querySelector('[data-cross-error]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-cross-error', '');
      el.setAttribute('role', 'status');
      el.style.cssText = 'font-size:10px;line-height:1.3;color:#8a8178;text-align:center;padding:4px 2px 0;width:100%;';
      card.appendChild(el);
    }
    el.textContent = msg || 'Could not add to bag';
    if (el._t) clearTimeout(el._t);
    el._t = setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 5000);
  }

  function refreshDrawerHtml() {
    // Run /cart.js (for the header bag count) and section re-fetch (for cross-sell + totals) in parallel
    var countPromise = fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bagCount = document.getElementById('bagCount');
        if (bagCount) bagCount.textContent = cart.item_count;
      })
      .catch(function () {});
    var drawerPromise = fetch(window.location.pathname + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('#cartDrawer');
        var oldDrawer = document.getElementById('cartDrawer');
        if (newDrawer && oldDrawer) {
          var wasOpen = oldDrawer.classList.contains('open');
          oldDrawer.outerHTML = newDrawer.outerHTML;
          if (wasOpen) {
            var fresh = document.getElementById('cartDrawer');
            if (fresh) fresh.classList.add('open');
          }
        }
      })
      .catch(function () {});
    return Promise.all([countPromise, drawerPromise]);
  }

  function bindCart() {
    var bagBtn = document.getElementById('bagBtn');
    var cartDrawer = document.getElementById('cartDrawer');
    var cartOverlay = document.getElementById('cartOverlay');
    var cartClose = document.getElementById('cartClose');
    if (!cartDrawer || !cartOverlay) return;
    var openCart = function () {
      var d = document.getElementById('cartDrawer');
      var o = document.getElementById('cartOverlay');
      if (d) d.classList.add('open');
      if (o) o.classList.add('open');
      document.body.style.overflow = 'hidden';
      refreshDrawerHtml();
    };
    var closeCart = function () {
      var d = document.getElementById('cartDrawer');
      var o = document.getElementById('cartOverlay');
      if (d) d.classList.remove('open');
      if (o) o.classList.remove('open');
      document.body.style.overflow = '';
    };
    // Delegate so handlers survive drawer re-renders
    document.addEventListener('click', function (e) {
      if (e.target.closest('#bagBtn')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('#cartClose')) { e.preventDefault(); closeCart(); return; }
      if (e.target.closest('#cartOverlay')) { closeCart(); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    // Listen for ATC clicks across the site (delegate)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        var fd = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function () { openCart(); })
          .catch(function () { form.submit(); });
      }
    });
  }

  function fmtMoney(cents) {
    var amt = cents / 100;
    // Follow the shopper's market, not the shop's base currency. Intl also
    // places the symbol correctly — "319 kr", not "kr319".
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    var loc = (window.Shopify && Shopify.locale) || 'en-GB';
    try {
      return new Intl.NumberFormat(loc, { style: 'currency', currency: code }).format(amt);
    } catch (e) {
      return code + ' ' + amt.toFixed(2);
    }
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function renderCart(cart) {
    var bagCount = document.getElementById('bagCount');
    if (bagCount) bagCount.textContent = cart.item_count;

    var headCount = document.querySelector('.cart-head h3 span');
    if (headCount) headCount.textContent = '(' + cart.item_count + ')';

    var itemsEl = document.querySelector('.cart-items');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p><em>Your bag is empty.</em></p><a href="/collections/all" class="btn">Shop the collection →</a></div>';
    } else {
      var sizedImg = function (url, w) {
        if (!url) return '';
        // Shopify Files CDN supports ?width= for resizing
        var sep = url.indexOf('?') === -1 ? '?' : '&';
        return url + sep + 'width=' + w;
      };
      var html = cart.items.map(function (item) {
        var altText = (item.product_title || item.title || '').replace(/"/g, '&quot;');
        var img = item.image ? ('<img class="cart-item-img" src="' + sizedImg(item.image, 192) + '" alt="' + altText + '" loading="lazy" />') : '<div class="cart-item-img" style="background:linear-gradient(135deg,#E8B5A2,#C68574);"></div>';
        var priceBlock = '<div class="cart-item-prices"><span class="cart-item-price">' + fmtMoney(item.final_line_price) + '</span>' +
          (item.original_line_price > item.final_line_price ? '<span class="cart-item-was">' + fmtMoney(item.original_line_price) + '</span>' : '') +
          '</div>';
        return '<div class="cart-item" data-key="' + item.key + '">' +
          img +
          '<div class="cart-item-info">' +
          '<div class="cart-item-row1"><h4>' + ((item.product && item.product.title) || item.product_title || (item.title || '').split(' - ')[0] || '') + '</h4>' + priceBlock + '</div>' +
          (item.variant_title ? '<div class="cart-item-shade"><em>' + item.variant_title + '</em></div>' : '') +
          '<div class="cart-item-row2">' +
          '<div class="cart-qty"><button data-act="dec" data-key="' + item.key + '" type="button">−</button><input type="text" value="' + item.quantity + '" readonly /><button data-act="inc" data-key="' + item.key + '" type="button">+</button></div>' +
          '<button class="cart-remove" data-act="remove" data-key="' + item.key + '" type="button">Remove</button>' +
          '</div>' +
          '</div>' +
          '</div>';
      }).join('');
      itemsEl.innerHTML = html;
    }

    // Compute total savings
    var totalSavings = 0;
    (cart.items || []).forEach(function (it) {
      if (it.original_line_price > it.final_line_price) totalSavings += (it.original_line_price - it.final_line_price);
    });
    if (cart.total_discount > 0) totalSavings += cart.total_discount;

    var foot = document.querySelector('.cart-foot');
    if (foot) {
      var savingsRow = foot.querySelector('.cart-savings');
      var totalRow = foot.querySelector('.cart-foot-row.total');
      if (totalSavings > 0) {
        if (!savingsRow) {
          savingsRow = document.createElement('div');
          savingsRow.className = 'cart-foot-row cart-savings';
          savingsRow.innerHTML = '<span>You save</span><span class="amt">−' + fmtMoney(totalSavings) + '</span>';
          if (totalRow) foot.insertBefore(savingsRow, totalRow);
          else foot.insertBefore(savingsRow, foot.firstChild);
        } else {
          savingsRow.querySelector('.amt').textContent = '−' + fmtMoney(totalSavings);
        }
      } else if (savingsRow) {
        savingsRow.remove();
      }
    }

    var subtotalRow = Array.prototype.find.call(
      document.querySelectorAll('.cart-foot-row'),
      function (r) { return r.querySelector('span') && r.querySelector('span').textContent === 'Subtotal'; }
    );
    if (subtotalRow) subtotalRow.querySelector('.amt').textContent = fmtMoney(cart.items_subtotal_price || cart.total_price);

    var totalEl = document.querySelector('.cart-foot-row.total .amt');
    if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);

    // Free-shipping progress. Threshold and copy come from Liquid via data
    // attributes so every market gets its own figure and language.
    var progWrap = document.querySelector('.cart-progress');
    var prog = document.querySelector('.cart-progress span em');
    if (progWrap && prog) {
      var threshold = parseInt(progWrap.getAttribute('data-threshold'), 10);
      if (isNaN(threshold)) threshold = 4000;
      var label = progWrap.getAttribute('data-ship-label') || 'shipping';
      var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      var fill = document.querySelector('.cart-progress-fill');
      if (fill) fill.style.width = pct + '%';
      if (cart.total_price >= threshold) {
        prog.innerHTML = (progWrap.getAttribute('data-msg-unlocked') || '<strong>Free {label}</strong> unlocked.')
          .replace('{label}', label);
        progWrap.classList.add('cart-progress--unlocked');
      } else {
        prog.innerHTML = (progWrap.getAttribute('data-msg-remaining') || "<strong>{amount} away</strong> from free {label}.")
          .replace('{amount}', fmtMoney(threshold - cart.total_price))
          .replace('{label}', label);
        progWrap.classList.remove('cart-progress--unlocked');
      }
    }
  }

  // Cross-sell swatch click — updates the card's hidden variant input
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-cross-swatch]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('[data-cross-card]');
    if (!card) return;
    card.querySelectorAll('[data-cross-swatch]').forEach(function (s) {
      s.classList.remove('active');
      s.setAttribute('aria-checked', 'false');
    });
    sw.classList.add('active');
    sw.setAttribute('aria-checked', 'true');
    var hidden = card.querySelector('[data-cross-variant]');
    if (hidden) hidden.value = sw.dataset.variantId;
  });

  // Cross-sell quick-add — if multi-variant, show swatch picker first; then add
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-cross-add]');
    if (!addBtn) return;
    e.preventDefault();
    var card = addBtn.closest('[data-cross-card]');
    if (!card) return;
    var swatches = card.querySelector('.cart-drawer-cross-swatches');
    var hasSwatches = swatches && swatches.children.length > 0;

    // If multi-variant and NOT already picking → show swatch popup
    if (hasSwatches && !card.classList.contains('picking')) {
      // Close any other open pickers
      document.querySelectorAll('.cart-drawer-cross-card.picking').forEach(function (c) {
        c.classList.remove('picking');
      });
      card.classList.add('picking');
      return;
    }

    // Close picker + add to cart
    card.classList.remove('picking');
    var picker = card.querySelector('[data-cross-variant]');
    var vid = picker ? picker.value : addBtn.dataset.crossAdd;
    if (!vid) return;
    addBtn.disabled = true;
    addBtn.classList.add('is-adding');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || '');
        return refreshDrawerHtml();
      })
      .catch(function (err) {
        addBtn.disabled = false;
        addBtn.classList.remove('is-adding');
        crossAddError(card, err && err.message);
      });
  });

  // Close swatch picker when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cross-card]')) {
      document.querySelectorAll('.cart-drawer-cross-card.picking').forEach(function (c) {
        c.classList.remove('picking');
      });
    }
  });

  // After swatch selection, auto-add (click + on a picking card = add with selected swatch)
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-cross-swatch]');
    if (!sw) return;
    var card = sw.closest('[data-cross-card]');
    if (!card) return;
    // After selecting swatch, trigger add
    setTimeout(function () {
      var addBtn = card.querySelector('[data-cross-add]');
      if (addBtn && !addBtn.disabled) {
        card.classList.remove('picking'); // close picker
        var picker = card.querySelector('[data-cross-variant]');
        var vid = picker ? picker.value : '';
        if (!vid) return;
        addBtn.disabled = true;
        addBtn.classList.add('is-adding');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || '');
            return refreshDrawerHtml();
          })
          .catch(function (err) {
            addBtn.disabled = false;
            addBtn.classList.remove('is-adding');
            crossAddError(card, err && err.message);
          });
      }
    }, 150); // small delay so swatch visually activates first
  });

  // Cart item interactions (delegate; survives drawer re-renders)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]');
    if (!btn) return;
    var key = btn.dataset.key;
    if (!key) return;
    var act = btn.dataset.act;
    var qtyInput = btn.parentElement.querySelector('input');
    var newQty;
    if (act === 'inc') newQty = parseInt(qtyInput.value, 10) + 1;
    else if (act === 'dec') newQty = Math.max(0, parseInt(qtyInput.value, 10) - 1);
    else if (act === 'remove') newQty = 0;
    if (newQty === undefined) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    }).then(function (r) { return r.json(); }).then(function () { return refreshDrawerHtml(); });
  });

  // ----- Scroll reveal -----
  function bindReveal() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  // ----- FAQ accordion -----
  function bindFaq() {
    document.querySelectorAll('.faq-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.closest('.faq-item');
        if (item) item.classList.toggle('open');
      });
    });
  }

  // ----- Multibuy picker (PDP) -----
  function bindMultibuy() {
    document.querySelectorAll('.multibuy').forEach(function (mb) {
      mb.querySelectorAll('.mb-option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          mb.querySelectorAll('.mb-option').forEach(function (o) { o.classList.remove('active'); });
          opt.classList.add('active');
          var qty = opt.dataset.qty;
          var qtyInput = document.querySelector('input[name="quantity"]');
          if (qtyInput && qty) qtyInput.value = qty;
        });
      });
    });
  }

  // ----- Shade picker (PDP) -----
  function bindShades() {
    document.querySelectorAll('.shade-row').forEach(function (row) {
      row.querySelectorAll('.shade-wrap').forEach(function (sw) {
        sw.addEventListener('click', function () {
          row.querySelectorAll('.shade-wrap').forEach(function (s) { s.classList.remove('active'); });
          sw.classList.add('active');
          var variantId = sw.dataset.variantId;
          var idInput = document.querySelector('input[name="id"]');
          if (idInput && variantId) idInput.value = variantId;
        });
      });
    });
  }

  // ----- Sticky ATC (PDP, mobile) -----
  // Only show the sticky once BOTH conditions are true:
  //   1. User has scrolled past the main ATC button (so it's offscreen above)
  //   2. User has scrolled at least SCROLL_MIN px (avoids race-on-load flash)
  function bindStickyAtc() {
    var sticky = document.querySelector('.sticky-atc');
    var trigger = document.querySelector('.atc');
    if (!sticky || !trigger) return;
    sticky.classList.remove('show');

    var SCROLL_MIN = 600;            // user must scroll at least this much
    var seenAtc = false;             // has the main ATC ever entered viewport?
    var atcHidden = false;           // is main ATC currently out of viewport?

    function refresh() {
      var scrolledEnough = window.scrollY >= SCROLL_MIN;
      sticky.classList.toggle('show', seenAtc && atcHidden && scrolledEnough);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) seenAtc = true;
        atcHidden = !e.isIntersecting;
        refresh();
      });
    }, { threshold: 0 });
    io.observe(trigger);

    window.addEventListener('scroll', refresh, { passive: true });
  }

  // ----- Before/After drag -----
  function bindBeforeAfter() {
    document.querySelectorAll('.ba-wrap').forEach(function (wrap) {
      var handle = wrap.querySelector('.ba-handle');
      var divider = wrap.querySelector('.ba-divider');
      var after = wrap.querySelector('.ba-img.ba-after');
      if (!handle || !divider) return;
      var dragging = false;
      var move = function (clientX) {
        var rect = wrap.getBoundingClientRect();
        var pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
        divider.style.left = pct + '%';
        handle.style.left = pct + '%';
        if (after) after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      };
      handle.addEventListener('mousedown', function () { dragging = true; });
      handle.addEventListener('touchstart', function () { dragging = true; });
      document.addEventListener('mousemove', function (e) { if (dragging) move(e.clientX); });
      document.addEventListener('touchmove', function (e) { if (dragging && e.touches[0]) move(e.touches[0].clientX); });
      document.addEventListener('mouseup', function () { dragging = false; });
      document.addEventListener('touchend', function () { dragging = false; });
    });
  }

  // Carousel dots — auto-attach to any swipeable grid on mobile
  function bindCarouselDots() {
    if (window.matchMedia && !window.matchMedia('(max-width: 768px)').matches) return;
    var selectors = [
      '.hp-promise-grid', '.icons-grid', '.hp-collection-grid',
      '.lookbook-grid', '.timeline-grid', '.testimonials-grid',
      '.bundle-grid', '.stats-grid', '.press-quotes-grid'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (track) {
        var children = track.children;
        if (!children || children.length < 2) return;
        if (track.nextElementSibling && track.nextElementSibling.classList.contains('carousel-dots')) return;
        var dots = document.createElement('ol');
        dots.className = 'carousel-dots';
        for (var i = 0; i < children.length; i++) {
          var li = document.createElement('li');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'carousel-dot' + (i === 0 ? ' active' : '');
          btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          btn.dataset.idx = i;
          btn.addEventListener('click', function () {
            var idx = parseInt(this.dataset.idx, 10);
            if (track.children[idx]) {
              track.scrollTo({ left: track.children[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
            }
          });
          li.appendChild(btn);
          dots.appendChild(li);
        }
        track.parentNode.insertBefore(dots, track.nextSibling);
        var t;
        track.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            var best = 0, bestDist = Infinity;
            for (var i = 0; i < track.children.length; i++) {
              var d = Math.abs(track.children[i].offsetLeft - track.offsetLeft - track.scrollLeft);
              if (d < bestDist) { bestDist = d; best = i; }
            }
            dots.querySelectorAll('.carousel-dot').forEach(function (d, di) {
              d.classList.toggle('active', di === best);
            });
          }, 80);
        }, { passive: true });
      });
    });
  }

  // Init
  document.addEventListener('DOMContentLoaded', function () {
    bindMobileNav();
    bindCart();
    bindReveal();
    bindFaq();
    bindMultibuy();
    bindShades();
    bindStickyAtc();
    bindBeforeAfter();
    bindCarouselDots();
    refreshCart();
  });
})();
